import { forwardRef } from 'react'
import { AudioBlock, type CommonBlockProps } from '../../../types'
import { webchatClasses } from '../../../styles/classes'

type Props = AudioBlock & CommonBlockProps
export const Audio = forwardRef<HTMLAudioElement, Props>(({ url, isReadOnly, ...props }, ref) => {
  const {
    message: {
      blocks: { audio },
    },
  } = webchatClasses
  return (
    <div>
      <audio
        {...props}
        controls
        style={isReadOnly ? { pointerEvents: 'none' } : undefined}
        src={url}
        {...audio}
        ref={ref}
      />
    </div>
  )
})

Audio.displayName = 'Audio'
